export const environmentVariables: any = {
    "ACCOUNT_INFORMATION_LINK": "https://account.dat.com/profile",
    "ANALYTICS_API_BASE_URL": "https://analytics.api.dat.com",
    "ANALYTICS_BASE_URL": "https://analytics.api.dat.com",
    "API_BASE_URL": "https://identity.api.dat.com",
    "APP_NAME": "DAT iQ",
    "BATCH_UTC_TIME": 11,
    "BA_ROOT_URL": "https://analytics.api.dat.com/benchmark",
    "CACHE_BREAKER_QUERY": "trendlines-prod-1.1.2",
    "DATADOG_RUM_APPLICATION_ID": "cf324e8a-dfbf-42af-b36a-a433386d28d5",
    "DATADOG_RUM_CLIENT_TOKEN": "pubcd242f336e1ecb3f424470ea3e1ebe4f",
    "DATADOG_RUM_ENVIRONMENT": "prod",
    "DATADOG_RUM_SERVICE_NAME": "dat-iq-trendlines",
    "DATADOG_RUM_TRACING_URL": "https://analytics.api.dat.com",
    "ENVIRONMENT": "prod",
    "EXTENDED_API_TARGET_DOMAINS": [],
    "FREIGHT_SUGGESTION_ENDPOINT": "https://analytics.api.dat.com/geo/v2/points/suggestions",
    "GOOGLE_MAPS_KEY": "AIzaSyCe80DR8a-3ba3bEbHeALuMDR8KeNaQEF4",
    "GRAPHQL_URL": "https://analytics.api.dat.com/analyticsfacade/graphql",
    "GRAPHQL_URL_ONE": "https://freight.api.dat.com/one-web-bff/graphql",
    "IDENTITY_API_BASE_URL": "https://identity.api.dat.com",
    "IQ_BASE_URL": "https://iq.dat.com",
    "OAUTH2_CONFIG": {
        "audience": "https://prod-api.dat.com",
        "client_domain": "login.dat.com",
        "client_id": "5BY2QFJvxldeYrSZtHCKD7tNMGTvd7q8"
    },
    "OPTIMIZELY_CONFIG": {
        "dataFileUrl": "https://cdn.optimizely.com/datafiles/5jYRyMHfn5dtZPyVV3Snp.json",
        "fetchPollingSeconds": 20,
        "logLevel": 3,
        "sdkKey": "5jYRyMHfn5dtZPyVV3Snp"
    },
    "RFP_ROOT_URL": "https://analytics.api.dat.com/rfp-service",
    "SEGMENT_KEY": "GPImU52FQyr4BnoCfuua2OROR7xN40zj",
    "TRUCKER_API_BASE_URL": "https://freight.api.dat.com/trucker",
    "USURP_CONFIG": {
        "apiBaseUrl": "https://identity.api.dat.com"
    },
    "X_DAT_DEPLOYMENT": "prod"
};

